import { render, staticRenderFns } from "./ScreenMain.vue?vue&type=template&id=f55194fe&scoped=true"
import script from "./ScreenMain.vue?vue&type=script&lang=js"
export * from "./ScreenMain.vue?vue&type=script&lang=js"
import style0 from "./ScreenMain.vue?vue&type=style&index=0&id=f55194fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55194fe",
  null
  
)

export default component.exports